export default "__VITE_ASSET__BgiDLEer__"